module.exports = __webpack_public_path__ + "img/00000.ae12e008.webp";